// src/components/ShareTabDownloadPopup.js
import React from "react";
import Popup from "reactjs-popup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Bot from "../services/bot";

const TIMEZONE = "Asia/Kolkata";

export default class ShareTabDownloadPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // dates
      startDate: new Date(),
      endDate:   new Date(),

      // notification/template
      notificationType: "erp",
      userTypes: [],
      selectedOptionUserType: null,
      selectAllTemplates: false,

      // mode
      mode: "once", // "once" | "scheduled"

      // scheduling
      scopeMode: "relative", // "relative" | "fixed"
      scopeValue: 1,         // number
      scopeUnit: "days",     // "days" | "months"
      freqValue: 1,          // number
      freqUnit:  "months",     // "days" | "months"
      emailsInput: ""        // text
    };

    this.closeInfoModal = this.closeInfoModal.bind(this);
    this.exportData     = this.exportData.bind(this);
  }

  componentDidMount() {
    Bot.getTempltes()
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({ userTypes: res.data.result });
        }
      })
      .catch(console.error);
  }

  closeInfoModal() {
    this.props.onChange(false);
  }

  exportData() {
    const {
      startDate, endDate,
      notificationType, selectedOptionUserType,
      mode, scopeMode,
      scopeValue, scopeUnit,
      freqValue, freqUnit,
      emailsInput,
      selectAllTemplates
    } = this.state;

    // --- CHANGE START: Validation & Value Assignment ---

    // 1. Validation: If Select All is FALSE and no template is selected -> Alert
    if (!selectAllTemplates && !selectedOptionUserType) {
      return alert("Please select a Template Name or check 'Select All'.");
    }

    // 2. Compatibility: If Select All is TRUE -> send null. 
    //    If FALSE -> send the specific selected option.
    const finalUserType = selectAllTemplates ? null : selectedOptionUserType;
    
    // --- CHANGE END ---
    // parse recipients
    const emails = emailsInput.split(",").map(e=>e.trim()).filter(Boolean);
    if (mode === "scheduled" && emails.length === 0) {
      return alert("Enter at least one email address.");
    }

    // prepare common args
    const exportArgs = {
      startDate,
      endDate,
      notificationType,
      selectedOptionUserType: finalUserType
    };

    // build scheduleConfig
    const scheduleConfig = { mode, timezone: TIMEZONE };

    if (mode === "scheduled") {
      // frequency validation
      if (!freqValue || freqValue < 1) {
        return alert("Enter a valid frequency.");
      }
      scheduleConfig.emails    = emails;
      scheduleConfig.frequency = { unit: freqUnit, interval: freqValue };

      if (scopeMode === "relative") {
        // scope validation
        if (!scopeValue || scopeValue < 1) {
          return alert("Enter a valid Last N value.");
        }
        scheduleConfig.scope = { type: `last_n_${scopeUnit}`, n: scopeValue };
      } else {
        // fixed-range validation
        if (startDate > endDate) {
          return alert("Select a valid date range for Fixed Range.");
        }
        scheduleConfig.scope     = { type: "fixed_range" };
        scheduleConfig.dateRange = {
          from: startDate.toISOString().slice(0,10),
          to:   endDate  .toISOString().slice(0,10)
        };
      }
    }

    this.props.onExportJobStart(exportArgs, scheduleConfig);
    this.closeInfoModal();
  }

  render() {
    const open = this.props.openInfoPopup;
    const {
      startDate, endDate,
      notificationType, userTypes, selectedOptionUserType,
      mode, scopeMode,
      scopeValue, scopeUnit,
      freqValue, freqUnit,
      emailsInput
    } = this.state;

    const templateOptions = userTypes.map(t => ({
      label: t.templateName,
      value: t._id
    }));

    const notificationTypeOptions = [
      { value: "erp",    label: "ERP"    },
      { value: "csv",    label: "CSV"    },
      { value: "manual", label: "Manual" }
    ];

    const unitOptions = [
      { value: "days",   label: "Days"   },
      { value: "months", label: "Months" }
    ];

    return (
      <Popup open={open} onClose={this.closeInfoModal} closeOnDocumentClick>
        <div className="card">
         <div className="card-header d-flex justify-content-between align-items-center">
            <h2 className="mb-0">Download as Excel</h2>
            <a
              className="card-options-remove cursorPointer"
              onClick={this.closeInfoModal}
              style={{ cursor: "pointer" }}
            >
              <i className="fe fe-x" />
            </a>
          </div>

          <div className="card-body">
            <div className="row">
              {/* Mode */}
              <div className="col-12 mb-3">
                <label>Mode</label>
                <div>
                  <label className="mr-4">
                    <input
                      type="radio"
                      name="mode"
                      value="once"
                      checked={mode==="once"}
                      onChange={()=>this.setState({mode:"once"})}
                    /> One-Time
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="mode"
                      value="scheduled"
                      checked={mode==="scheduled"}
                      onChange={()=>this.setState({mode:"scheduled", scopeMode:"relative"})}
                    /> Scheduled
                  </label>
                </div>
              </div>

              {/* From/To pickers */}
              <div className="col-6 col-sm-4 col-lg-4 mb-3">
                <label>From Date</label>
                <DatePicker
                  className="form-control"
                  selected={startDate}
                  onChange={d=>this.setState({startDate:d})}
                  maxDate={endDate}
                  dateFormat="dd/MM/yyyy"
                  disabled={mode==="scheduled" && scopeMode==="relative"}
                />
              </div>
              <div className="col-6 col-sm-4 col-lg-4 mb-3">
                <label>To Date</label>
                <DatePicker
                  className="form-control"
                  selected={endDate}
                  onChange={d=>this.setState({endDate:d})}
                  dateFormat="dd/MM/yyyy"
                  disabled={mode==="scheduled" && scopeMode==="relative"}
                />
              </div>

              {/* Scheduled-only */}
              {mode==="scheduled" && (
                <>
                  {/* Scope Type */}
                  <div className="col-12 mb-2">
                    <label>Scope Type</label>
                    <div>
                      <label className="mr-4">
                        <input
                          type="radio"
                          name="scopeMode"
                          value="relative"
                          checked={scopeMode==="relative"}
                          onChange={()=>this.setState({scopeMode:"relative"})}
                        /> Last N
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="scopeMode"
                          value="fixed"
                          checked={scopeMode==="fixed"}
                          onChange={()=>this.setState({scopeMode:"fixed"})}
                        /> Fixed Range
                      </label>
                    </div>
                  </div>

                  {/* Last N */}
                  {scopeMode==="relative" && (
                    <div className="col-6 col-sm-4 col-lg-4 mb-3">
                      <label>Last N</label>
                      <div className="d-flex">
                        <input
                          type="number" min="1"
                          className="form-control mr-2"
                          style={{maxWidth:"80px"}}
                          value={scopeValue}
                          onChange={e=>this.setState({scopeValue:parseInt(e.target.value,10)||""})}
                        />
                        <Select
                          options={unitOptions}
                          value={unitOptions.find(u=>u.value===scopeUnit)}
                          onChange={opt=>this.setState({scopeUnit:opt.value})}
                          className="flex-grow-1"
                          styles={{
                            container: provided => ({
                              ...provided,
                              minWidth: 120,      // at least 120px wide
                            })
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {/* Frequency */}
                  <div className="col-6 col-sm-4 col-lg-4 mb-3">
                    <label>Frequency</label>
                    <div className="d-flex">
                      <input
                        type="number" min="1"
                        className="form-control mr-2"
                        style={{maxWidth:"80px"}}
                        value={freqValue}
                        onChange={e=>this.setState({freqValue:parseInt(e.target.value,10)||""})}
                      />
                      <Select
                        options={unitOptions}
                        value={unitOptions.find(u=>u.value===freqUnit)}
                        onChange={opt=>this.setState({freqUnit:opt.value})}
                        className="flex-grow-1"
                          styles={{
                            container: provided => ({
                              ...provided,
                              minWidth: 120,      // at least 120px wide
                            })
                          }}
                      />
                    </div>
                  </div>

                  {/* Recipients */}
                  <div className="col-6 col-sm-4 col-lg-4 mb-3">
                    <label>Recipients</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="a@x.com, b@y.com"
                      value={emailsInput}
                      onChange={e=>this.setState({emailsInput:e.target.value})}
                    />
                    <small className="form-text text-muted">
                      Comma-separated emails
                    </small>
                  </div>
                </>
              )}

              {/* Notification Type */}
              <div className="col-6 col-sm-4 col-lg-4 mb-3">
                <label>Notification Type</label>
                <Select
                  options={notificationTypeOptions}
                  value={notificationTypeOptions.find(o=>o.value===notificationType)}
                  onChange={opt=>this.setState({notificationType:opt.value})}
                />
              </div>

              {/* Template */}
              <div className="col-6 col-sm-4 col-lg-4 mb-3">
                <label>Template Name</label>
                {/* --- ADD CHECKBOX START --- */}
                <div className="mb-1">
                  <label style={{ fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center" }}>
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={this.state.selectAllTemplates}
                      onChange={(e) => this.setState({ selectAllTemplates: e.target.checked })}
                    />
                    Select All
                  </label>
                </div>
                {/* --- ADD CHECKBOX END --- */}

                <Select
                  options={templateOptions}
                  isDisabled={this.state.selectAllTemplates}
                  value={templateOptions.find(o =>
                    selectedOptionUserType && o.value === selectedOptionUserType.value
                  )}
                  onChange={opt => this.setState({ selectedOptionUserType: opt })}
                />
              </div>

              {/* Submit */}
              <div className="col-6 col-sm-4 col-lg-4 mb-3">
                <button
                  className="btn btn-primary btn-block"
                  onClick={this.exportData}
                >
                  {mode==="once" ? "Request Report" : "Schedule Report"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Popup>
    );
  }
}
